module.exports = __webpack_public_path__ + "media/images/icon-menu-active-d0e8cc4f70107691a984c1fc5711dfac.svg";